import { post, put } from '../Services/http';
import { load as loadCart } from './Cart.action';
import { receive as receive } from './Cart.action';
import { setError } from './Address.action';
import { catchError } from './Error.action';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = 'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS = 'CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS';
export const CHECKOUT_SET_ORDERMARKING = 'CHECKOUT_SET_ORDERMARKING';
export const CHECKOUT_SET_DELIVERY_DATE = 'CHECKOUT_SET_DELIVERY_DATE';
export const CHECKOUT_ALLOW_PARTIAL = 'CHECKOUT_ALLOW_PARTIAL';
export const CHECKOUT_SET_PARTIAL_DELIVERIES = 'CHECKOUT_SET_PARTIAL_DELIVERIES';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_DELIVERY_ADDRESSES = 'CHECKOUT_SET_DELIVERY_ADDRESSES';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_CAMPAIGN_CODE = 'CHECKOUT_SET_CAMPAIGN_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = 'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_DONE = 'CHECKOUT_SUBMIT_DONE';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_SET_RESELLER = 'CHECKOUT_SET_RESELLER';
export const CHECKOUT_SET_GENERAL_VALUES = 'CHECKOUT_SET_GENERAL_VALUES';
export const CHECKOUT_OPEN_ADD_ADDRESS_MODAL = 'CHECKOUT_OPEN_ADD_ADDRESS_MODAL';
export const CHECKOUT_UPDATE_PAYLOAD = 'CHECKOUT_UPDATE_PAYLOAD';
export const CHECKOUT_SET_SELECTED_DELIVERY_CONDITION = 'CHECKOUT_SET_SELECTED_DELIVERY_CONDITION';
export const CHECKOUT_SET_SELECTED_OUR_REFERENCE = 'CHECKOUT_SET_SELECTED_OUR_REFERENCE';
export const CHECKOUT_UPDATE_SELECTED_DELIVERIES = 'CHECKOUT_UPDATE_SELECTED_DELIVERIES';


export const updateSelectedItem = (systemId, value) => (dispatch, getState) => {

    var selectedItems = getState().cart.selectedDeliveries;
    var exists = selectedItems.find(z => z.id == systemId);
    if (exists) {
        exists.selectedDeliveryDate = value;
    }
    dispatch(updateSelectedDeliveries(selectedItems));
}


export const updateSelectedDeliveries = selectedDeliveries => ({
    type: CHECKOUT_UPDATE_SELECTED_DELIVERIES,
    selectedDeliveries: selectedDeliveries
})

export const orderDeliveryDateChange = (systemId, value) => (dispatch, getState) => {

    return put(`/api/checkout/orderDeliveryDateChange`, { deliveryDateInfoValue: value, deliverySystemId: systemId })
        .then(response => response.json())
        //.then(dispatch(updateSelectedItem(systemId, value)))
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));

    return false;
}
//export const orderRowDeliveryDateChange = (rowSystemId, rowIndex, dateIndex) => (dispatch, getState) => {

//    let dateObject = {};
//    const orderRows = [...getState().cart.orderRows];

//    if (orderRows) {
//        dateObject = { ...orderRows[rowIndex].availableDatesToDeliverList[dateIndex] };
//    }

//    if (dateObject) {
//        if (orderRows) {
//            orderRows[rowIndex].selectedDeliveryDate = dateObject;
//            dispatch({
//                type: CART_ORDER_ROWS_UPDATE,
//                payload: {
//                    orderRows,
//                }
//            });
//        }
//        dateObject.rowSystemId = rowSystemId;

//        return put(`/api/checkout/orderDeliveryDateChange`, { deliveryDateInfoValue: dateObject.deliveryDateInfoValue, rowSystemId: dateObject.rowSystemId, deliveryDate: dateObject.deliveryDate })
//                .then(response => response.json())
//                .then(cart => dispatch(receive(cart)))
//                .catch(ex => dispatch(catchError(ex, error => loadError(error))))
//            ;
//    }

//    return false;
//}
export const setOrderMarking = (orderMarking) => (dispatch) => {
    dispatch({
        type: CHECKOUT_SET_ORDERMARKING,
        payload: {
            selectedOrderMarking: orderMarking
        }
    });
    if (document.getElementById("orderMarking") != null) {
        const $el = document.getElementById("orderMarking");
        return post('/api/checkout/setordermarking', $el.value)
            .then(response => response.json())
            .then(dispatch(loadCart()))
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    }
};

export const setDeliveryDate = (date) => (dispatch) => {
    dispatch({
        type: CHECKOUT_SET_DELIVERY_DATE,
        payload: {
            selectedDeliveryDate: date
        }
    });
    if (document.getElementById("delivery-date-picker") != null) {
        const $el = document.getElementById("delivery-date-picker");
        return post('/api/checkout/setdeliverydate', $el.value)
            .then(response => response.json())
            .then(dispatch(loadCart()))
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    }
};
export const setReseller = (id, paymentMethod) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_RESELLER,
        payload: {
            selectedResellerId: id,
            hasReseller: true,
            selectedPaymentMethod: paymentMethod
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setReseller', payload)
        .then(response => response.json())
        .then(result => {
            location.href = result.resellerUrl;
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}

export const setPartialDeliveries = (isAllowed) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_PARTIAL_DELIVERIES,
        payload: {
            allowPartialDeliveries: isAllowed,
        }
    });
    return put('/api/checkout/updatePartialDeliveries', isAllowed)
        .then(response => response.json())
        .then(dispatch(allowPartial(isAllowed)))
        .then(dispatch(loadCart()))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}
export const allowPartial = (allowPartial) => ({
    type: CHECKOUT_ALLOW_PARTIAL,
    payload: {
        allowPartial,
    }
})
const setPaymentMethodToUse = (paymentMethodToUse, selectedPaymentMethodToUse) => (
    {
        type: CHECKOUT_SET_PAYMENT_WIDGET,
        payload: {
            paymentMethodToUse,
            selectedPaymentMethodToUse
        }
    })
export const setBusinessCustomer = (isBusinessCustomer) => ({
    type: CHECKOUT_SET_PRIVATE_CUSTOMER,
    payload: {
        isBusinessCustomer,
    }
})

export const setSignUp = (signUp) => ({
    type: CHECKOUT_SET_SIGN_UP,
    payload: {
        signUp,
    }
})

export const setAlternativeAddress = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'alternativeAddress',
        data: {
            [propName]: value,
        },
    }
})

export const setCustomerDetails = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'customerDetails',
        data: {
            [propName]: value,
        },
    }
})

export const setSelectedCompanyAddress = (selectedCompanyAddressId) => ({
    type: CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    payload: {
        selectedCompanyAddressId,
    }
})

export const setSelectedDeliveryAddress = (selectedDeliveryAddressId) => (dispatch) => {
    dispatch({
        type: CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS,
        payload: {
            selectedDeliveryAddressId,
        }
    });
    return put('/api/checkout/setDeliveryAddress', {selectedDeliveryAddressId: selectedDeliveryAddressId})
    .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}



export const setSelectedOurReferece = (selectedOurRefereceId) => ({
    type: CHECKOUT_SET_SELECTED_OUR_REFERENCE,
    payload: {
        selectedOurRefereceId,
    }
})

export const setDelivery = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
            selectedDeliveryMethod: systemId,
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setDeliveryProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            if (result !== null) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}
//export const setSelectedDeliveryCondition = (selectedDeliveryConditionId) => ({
//    type: CHECKOUT_SET_SELECTED_DELIVERY_CONDITION,
//    payload: {
//        selectedDeliveryConditionId,
//    }
//})
export const setSelectedDeliveryCondition = (selectedDeliveryConditionId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_SELECTED_DELIVERY_CONDITION,
        payload: {
            selectedDeliveryConditionId,
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setDeliveryCondition', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            if (result !== null) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}

export const setPayment = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
            selectedPaymentMethod: systemId,
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setPaymentProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}

export const reloadPayment = () => (dispatch, getState) => {
    const { paymentWidget, selectedPaymentMethod } = getState().checkout.payload;
    if (!paymentWidget) {
        return;
    }
    return dispatch(setPayment(selectedPaymentMethod));
}

export const reloadCheckout = () => (dispatch, getState) => {
    const { payload } = getState().checkout;

    return put('/api/checkout/update', payload)
        .then(response => response.json())
        .then(response => dispatch(updateFullPayload(response)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

const setPaymentWidget = (paymentWidget) => ({
    type: CHECKOUT_SET_PAYMENT_WIDGET,
    payload: {
        paymentWidget,
    }
})

export const setOrderNote = (orderNote) => ({
    type: CHECKOUT_SET_ORDER_NOTE,
    payload: {
        orderNote,
    }
})

export const acceptTermsOfCondition = (acceptTermsOfCondition) => ({
    type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    payload: {
        acceptTermsOfCondition,
    }
})

export const updatePayloadData = (objectName, objectValue) => ({
    type: CHECKOUT_SET_GENERAL_VALUES,
    payload: {
        [objectName]: objectValue,
    }
})

export const updateDeliveryAddresses = (addresses) => ({
    type: CHECKOUT_SET_DELIVERY_ADDRESSES,
    payload: {
        deliveryAddresses: addresses,
    }
})

export const setCampaignCode = (campaignCode) => ({
    type: CHECKOUT_SET_CAMPAIGN_CODE,
    payload: {
        campaignCode,
    }
})

export const submitCampaignCode = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/setCampaignCode', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
            // reset error of campaign code
            dispatch(submitError({
                modelState: {
                    'campaignCode': []
                }
            }))
        })
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        })
}

export const submit = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return _submit('/api/checkout', payload, dispatch);
}

export const orderReleaseChange = (isChecked) => (dispatch, getState) => {

    // Update payload
    dispatch(updatePayloadData('releaseOrder', isChecked));
    const { payload } = getState().checkout;

    return put('/api/checkout/changeReleaseStatus', payload)
        .then(response => response.json())
        .then(response => dispatch(updatePayload(response)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const orderTypeChange = (orderTypeValue) => (dispatch, getState) => {

    // Update payload
    dispatch(updatePayloadData('orderType', orderTypeValue));
    const { payload } = getState().checkout;

    return put('/api/checkout/changeOrderTypeValue', payload)
        .then(response => response.json())
        .then(response => dispatch(updateFullPayload(response)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}



export const updateExternalText = (objectName, textValue) => (dispatch, getState) => {

    // Update payload
    dispatch(updatePayloadData(objectName, textValue));
}

export const addDeliveryAddress = (address, isTemporary) => (dispatch) => {

    address.addressType = 'Delivery';
    address.isTemporarySave = isTemporary;

    return post('/api/checkout/addDeliveryAddress', address)
        .then(response => response.json())
        .then(result => {
            dispatch(setDeliveryAddresses(result));
        })
        .then(response => dispatch(loadCart()))
        .then(result => {
            dispatch(showNewAddressModal(false));
        })
        //  .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const setDeliveryAddresses = (addresses) => (dispatch, getState) => {

    let deliveryAddresses = [];
    addresses.map((address, index) => {
        if (address.addressType === 'Delivery'){
            deliveryAddresses.push(address);
        }
            
    });

    dispatch(updateDeliveryAddresses(deliveryAddresses));
    return addresses;
}

export const verify = (url, orderId, payload) => (dispatch, getState) => {
    const model = getState().checkout.payload;
    model.orderId = orderId;
    model.payload = payload;
    return _submit(url, model, dispatch);
}

const _submit = (url, model, dispatch) => {
    return post(url, model)
        .then(response => response.json())
        .then(result => {
            dispatch(submitDone(result));
        })
        .catch(ex => {
            if (ex.response) {
                ex.response.json().then(error => {
                    dispatch(submitError(error));
                    dispatch(submitDone(null));
                    // reload the cart, it might be changed after validation
                    dispatch(loadCart());

                });
            } else {
                dispatch(submitError(ex));
            }
        })
        ;
}

export const validateOrder = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return post('/api/checkout/validateorder', payload)
        .then(response => response.json())
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            dispatch(loadCart());
            return false;
        });
};

export const showNewAddressModal = (modalState) => ({
    type: CHECKOUT_OPEN_ADD_ADDRESS_MODAL,
    payload: {
        newAddressModalIsOpen: modalState
    },
})


export const submitRequest = () => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        isSubmitting: true,
        errors: [],
    },
})

export const submitDone = result => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        result,
        isSubmitting: false,
    },
})



export const submitError = error => ({
    type: CHECKOUT_SUBMIT_ERROR,
    payload: {
        error,
    },
})

export const updateFullPayload = payload => ({
    type: CHECKOUT_UPDATE_PAYLOAD,
    payload,
})
